<template>
	<div>
		<div class="doctorPage doctorSeach">
			<div class="selectSearch">
				<el-form ref="form" :model="appealParameter" class="qcFrom" :inline="true">
					<el-form-item label="状态">
						<el-select v-model="appealParameter.appealStatus" placeholder="请选择状态" size="mini" class="name">
							<el-option label="未定义" value="0"></el-option>
							<el-option label="取消申诉" value="-2"></el-option>
							<el-option label="已申诉" value="142"></el-option>
							<el-option label="已转发" value="144"></el-option>
							<el-option label="已处理" value="146"></el-option>
							<el-option label="已审核" value="148"></el-option>
							<el-option label="已认可" value="160"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="报告编号">
						<el-input v-model="appealParameter.accNo" class="name" placeholder="请输入报告编号" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="设备类型">
						<el-select v-model="appealParameter.modalityType" placeholder="请选择设备类型" size="mini" class="name">
							<el-option v-for="(item,index) in modalityTypeSelect" :key="index" :label="item.text" :value="item.sorts"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="申诉时间">
						<el-date-picker
							class="time mar4"
							v-model="pickerDate.date"
							@change="datePicker"
							type="monthrange"
							size="mini"
							range-separator="至"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							value-format="yyyy/MM"
							format="yyyy-MM"
						></el-date-picker>
					</el-form-item>
					<el-form-item><el-button type="primary" @click="search" round>查询</el-button></el-form-item>
				</el-form>
			</div>

			<div class="centerHome">
				<div class="ccHomel">
					<div class="compentTable">
						<el-table class="qcTable" :data="appealInfoList" v-loading="loading">
							<el-table-column prop="AccNo" label="报告编号" min-width="100"></el-table-column>
							<el-table-column prop="ModalityType" label="设备类型"></el-table-column>
							<el-table-column prop="Id" label="任务编号"></el-table-column>
							<el-table-column prop="CheckingItems" label="检查项目"></el-table-column>
							<el-table-column prop="RawScore" label="平均分"></el-table-column>
							<el-table-column prop="ACreateDateTime" min-width="100" :formatter="formattertime" label="创建时间"></el-table-column>
							<el-table-column prop="ACreateDt" min-width="100" :formatter="formattertime" label="完成时间"></el-table-column>
							<el-table-column prop="AppealStatusName" label="状态"></el-table-column>
							<el-table-column prop="" label="操作" width="180">
								<template slot-scope="scope">
									<span class="tableOpe marr15" @click="experClick(scope.row)">查看</span>
									<span class="tableOpe textColorRed" v-if="scope.row.AppealStatus == 142" @click="withdraw(scope.row)">撤回</span>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
	data() {
		return {
			pickerDate: {},
			TaskListArrData: []
		};
	},
	computed: {
		...Vuex.mapState('breadcrumb', ['loading','modalityTypeSelect']),
		...Vuex.mapState('doctor', ['appealParameter','appealInfoList']),
		...Vuex.mapState('managerPlanList',['qcresultsList']),
	},
	activated() {
		this.GetAppealInfoList();
	},
	methods: {
		...Vuex.mapMutations('breadcrumb',['setqcresultsShow']),
		...Vuex.mapMutations('doctor', ['setisSubmintflag','samplingTaskGuid','setIsSubmint','setDetalLoading','setReportGuid', 'setDetailsParameter']),
		...Vuex.mapActions('doctor', ['GetReportDetail', 'GetReporterReportList','CancelAppealInfo','GetAppealInfoList']),
		...Vuex.mapActions('managerPlanList',['GetQCResultsByTask']),
		datePicker(event) {
			this.appealParameter.startDt = event[0];
			this.appealParameter.endDt = event[1];
		},
		withdraw(row){
			let _this = this;
			_this.$confirm('是否确定撤回该条申诉报告？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			}).then(() => {
				_this.CancelAppealInfo({
					AppealInfoGuid:row.AppealInfoGuid
				});
			}).catch((err) => {
				_this.$message({
					type: 'info',
					message: '已取消撤回'
				});
			});
			
		},
		search() {
			this.GetAppealInfoList();
		},
		experClick(val){
			this.setDetalLoading(true);
			//详情不可编辑
			this.setIsSubmint(true);
			this.setisSubmintflag(true);
			this.setqcresultsShow(false);
			this.qcresultsList.Name = val.Name;
			this.setReportGuid(val.ReportGuid);
			this.samplingTaskGuid.ExpertUserId = val.ExpertUserGuid;
			this.qcresultsList.expertUserId = val.ExpertUserGuid;
			this.qcresultsList.ReportGuid = val.ReportGuid;
			this.qcresultsList.SamplingTaskGuid = val.SamplingTaskGuid;
			this.qcresultsList.AppealInfoGuid = val.AppealInfoGuid;
		
			this.setDetailsParameter({
				reportGuid: this.qcresultsList.ReportGuid,
				samplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
				ExpertUserGuid: this.qcresultsList.expertUserId
			})
			this.GetQCResultsByTask({
				samplingtaskguid:this.qcresultsList.SamplingTaskGuid,
				reportGuid:this.qcresultsList.ReportGuid
			})
			// this.GetReportDetail();
			this.$router.push("/home/doctor/scoring");
		},
		formattertime(row, column, cellValue) {
			if (cellValue != '' && cellValue != null) {
				return cellValue.substring(0, cellValue.length - 3);
			} else {
				return cellValue;
			}
		}
	}
};
</script>
